import Echo from "laravel-echo";
import Pusher from 'pusher-js';
const pusherKey = process.env.REACT_APP_PUSHER_KEY

class EchoSingleton {

    static instance = null;

    constructor() {
        if (!EchoSingleton.instance) {
            EchoSingleton.instance = new Echo({
                broadcaster: "pusher",
                key: pusherKey,
                forceTLS: true,
                encrypted: true,
                disableStats: true,
                cluster: 'us2',
            });
        }
    }

    getEcho() {
        return EchoSingleton.instance;
    }
}

export const EchoInstance = new EchoSingleton();